// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { TypeFilterObject } from "@hex-insights/core";
import { ClassYearSelectField, ContractLineItemSelectField } from "../../Forms";
import { ServiceFormValues } from "../../FormUtilities";
import { registry } from "../registry";
import * as CustomFilterFormValues from "./form-values-custom";

export type FilterFormValues = CustomFilterFormValues.StandardFilterFormValues &
	IndexForms.SearchFormValues &
	IndexForms.FilterFormValues;

export const initial: FilterFormValues = {
	...CustomFilterFormValues.initialStandardFilters,
	...IndexForms.initialSearchFormValues,
	...IndexForms.initialFilterFormValues,
};

export function getInitial(initialFormValues?: Partial<FilterFormValues>): FilterFormValues {
	return { ...initial, ...initialFormValues };
}

export const typeFilterObject: TypeFilterObject<FilterFormValues> = {
	...CustomFilterFormValues.standardFiltersTypeFilterObject,
	...IndexForms.searchFormValuesFilterObject,
	...IndexForms.filterFormValuesFilterObject,
};

export const advancedFilterInformation: IndexForms.AdvancedFilterInformation = {
	fieldOptions: [
		{ value: "name" },
		{ value: "description" },
		{ value: "category" },
		{ value: "isActive" },
		{ value: "price" },
		{ value: "classYears" },
		{ value: "contractLineItems" },
	],
	fieldComparisonOptions: {
		name: IndexForms.stringComparisonOptions,
		description: IndexForms.stringComparisonOptions,
		category: IndexForms.enumComparisonOptions,
		isActive: IndexForms.booleanComparisonOptions,
		price: IndexForms.numberComparisonOptions,
		classYears: IndexForms.multipleEdgeComparisonOptions,
		contractLineItems: IndexForms.multipleEdgeComparisonOptions,
	},
	fieldComparisonTranslations: {
		name: IndexForms.stringComparisonTranslations,
		description: IndexForms.stringComparisonTranslations,
		category: IndexForms.getRadioComparisonTranslations(ServiceFormValues.categoryOptions),
		isActive: IndexForms.booleanComparisonTranslations,
		price: IndexForms.numberComparisonTranslations,
		classYears: IndexForms.getMultipleEdgeComparisonTranslations(
			ClassYearSelectField.Select,
			ClassYearSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		contractLineItems: IndexForms.getMultipleEdgeComparisonTranslations(
			ContractLineItemSelectField.Select,
			ContractLineItemSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
	},
};

registry.register("Service", advancedFilterInformation, {
	classYears: "ClassYear",
	contractLineItems: "ContractLineItem",
});
